import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import { useSpanishTranslationAccess } from '@/hooks/useSpanishTranslationAccess';
import { loadCatalog } from '@/lib/i18n';
import { applyDocumentLanguage, DEFAULT_LOCALE, getLocale, setLocale } from '@/lib/locale';
import { api } from '@/services/ApiService';

export const LocaleCatalog = () => {
    const dispatch = useDispatch();
    const { enabled, denied } = useSpanishTranslationAccess();

    useEffect(() => {
        if (!enabled) {
            return;
        }

        // English is bundled, so there is never a request to make for it.
        const locale = getLocale();
        if (locale === DEFAULT_LOCALE) {
            return;
        }

        applyDocumentLanguage(locale);
        // The bundle arrives after init, so the language switch has to wait for the fetch or
        // i18next reports the locale while still holding only English.
        void loadCatalog(locale).then(() => i18next.changeLanguage(locale));
    }, [enabled]);

    // Spanish is an Early Access feature. A reader who chose it and has since lost access (left Early
    // Access, had it revoked, signed out) goes back to English: the cookie would otherwise keep every
    // API call in Spanish under an English interface. The reset refetches anything already loaded in
    // Spanish, for the reason LanguageSwitcher gives.
    useEffect(() => {
        if (!denied || getLocale() === DEFAULT_LOCALE) {
            return;
        }

        setLocale(DEFAULT_LOCALE);
        applyDocumentLanguage(DEFAULT_LOCALE);
        void i18next.changeLanguage(DEFAULT_LOCALE);
        dispatch(api.util.resetApiState());
    }, [denied, dispatch]);

    return null;
};
